declare namespace $ {

	export class $company_template_logo extends $mol_icon_molecule {
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map